module.exports = __webpack_public_path__ + "static/favicon-96x96-da2975043cc3040524b0bd9039aa5f98.png";